import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';

import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  InvoiceModel,
  InvoiceStatusUpdateModel
} from '../models/invoice.model';
import { InvoiceService } from '../models/invoice.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  DataListModel,
  IKeyValueInterface,
  WeGoAuthorizedLink,
  Permission,
  PermissionType
} from '../../shared/config';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';
import { FlatPickrModel } from '../../plugins/flatpickr/flatpickr.model';
import { DirectDebitFileXML } from '../models/direct-debit-file.model';
import { reduce } from 'rxjs/operator/reduce';
import { InvoiceStatusEnum } from '../../shared/models/enum-helper';
import { DropdownModel } from '../../report/models/report-filter.model';

const $ = require('jquery');
const SlimSelect = require('slim-select');

@Component({
  selector: 'wego-invoice-list',
  template: require('../views/invoice-list.component.html'),
  providers: [InvoiceService, JQueryHelperService],
  styles: [
    `
      .invoiceLinkDisabled {
        cursor: not-allowed;
      }

      .inputWidth-100-Percent {
        width: 100%;
      }

      .modal-body {
        word-wrap: break-word;
      }
    `
  ]
})
export class InvoiceListComponent implements OnInit {
  statusUpdateModalMsg: string;
  dueDateUpdatedDate: string;
  statusUpdateReason: string;
  dueDateValidationMessage: string;
  urlInvoice: string;
  urlPaymentHistory: string;
  addInvoiceLink: WeGoAuthorizedLink;
  DataListModel: DataListModel;
  invoiceList: InvoiceModel[];
  invoiceModel: InvoiceModel = new InvoiceModel();
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  confirmMsg: string;
  invoiceNumber: string;
  invoiceHashId: string;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  public dateTimeFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  flatPickrConfigTo: FlatPickrModel;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigDueDate: FlatPickrModel;
  errorModel: IKeyValueInterface[];
  deleteMessage: string;
  _directDebitFileXML: DirectDebitFileXML[];
  urlDriverInfo: string;
  urlOrganizationInfo: string;
  itemPerPageList: number[] = WeGoConfig.GRID_PAGGING;
  private popupMsg: string;
  private errorPopupMsg: string;
  private errorPopupTitle: string;
  private module: string;
  isDirectDebitEnabled: false;
  selectedFormat: string = 'default';
  invoiceStatusUpdateModel: InvoiceStatusUpdateModel;
  invoiceOpenCloseReasonList: DropdownModel[];
  InvoiceStatusAll: { Key: string; Value: string }[];
  InvoiceStatus: { Key: string; Value: string }[];
  invoiceStatusSelect: any;
  LblSelect: string;
  LblStatus: string;
  searchDriverName: string;

  public LEGACY_API_BASE_URL = WeGoConfig.LEGACY_API_BASE_URL;
  @ViewChild('editDueDateModal') public editDueDateModal: any;
  @ViewChild('resendConfirmModal') public resendConfirmModal: any;
  @ViewChild('deleteConfirmModal') public deleteConfirmModal: any;
  @ViewChild('manualCloseInvoiceConfirmModal')
  public manualCloseInvoiceModal: any;
  @ViewChild('invoiceStatusUpdateModal') public invoiceStatusUpdateModal: any;
  @ViewChild('reOpenInvoiceConfirmModal') public reOpenInvoiceModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('errorPopup') public errorPopup: any;
  @ViewChild('missingABANNumber') public missingABANNumber: any;
  @ViewChild('createDirectDebitModel') public createDirectDebitModel: any;
  @ViewChild('manualInvoicePopup') public manualInvoicePopup: any;

  constructor(
    private invoiceService: InvoiceService,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private jQueryHelperService: JQueryHelperService
  ) { }

  ngOnInit() {
    this.module = this.translate.instant('LblBookingInvoice');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = [
      'translatedStatus',
      'invoiceNumber',
      'sharedVehicleGroup',
      'addressee',
      'invoiceType'
    ];

    this.InvoiceStatusAll = [
      {
        Key: this.translate.instant("LblOPEN"),
        Value: 'OPEN'
      },
      {
        Key: this.translate.instant("LblSENT"),
        Value: 'SENT'
      },
      {
        Key: this.translate.instant("LblCLOSED"),
        Value: 'CLOSED'
      },
      {
        Key: this.translate.instant("LblREQUESTFORPAYMENT"),
        Value: 'REQUESTFORPAYMENT'
      },
      {
        Key: this.translate.instant("LblREOPEN"),
        Value: 'REOPEN'
      }
    ];

    this.InvoiceStatus = this.InvoiceStatusAll;
    this.invoiceModel.invoiceStatusList = this.InvoiceStatus.map(x => x.Value);
    this.invoiceModel.status = '';
    //this.invoiceStatusSelect.set(this.invoiceModel.invoiceStatusList);

    this.LblSelect = this.translate.instant('LblSelect');
    this.LblStatus = this.translate.instant('LblStatus');

    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlDriverInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );
    this.urlOrganizationInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_ORGANIZATION_UPDATE
    );
    this.urlInvoice = this.authService.GetURL(
      ApplicationRouteURL.URL_INVOICE_UPDATE
    );
    this.urlPaymentHistory = this.authService.GetURL(
      ApplicationRouteURL.URL_PAYMENT_HISTORY
    );

    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigDueDate = this.SetFlatPickrConfigForDueDate();

    this.addInvoiceLink = new WeGoAuthorizedLink(
      this.urlInvoice,
      Permission.PR_INVOICE,
      PermissionType.INSERT,
      'btn btn-highlight navbar-right',
      'LblAddNew'
    );

    this.invoiceStatusUpdateModel = new InvoiceStatusUpdateModel();
    if (this.itemPerPageList.indexOf(500) < 0) {
      this.itemPerPageList.push(500);
      this.itemPerPageList.push(1000);
    }
    this.GetIvoiceList();
  }

  ngAfterViewInit() {
    this.RenderBookingStatus();
    this.invoiceStatusSelect.set(this.invoiceModel.invoiceStatusList);
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  private SetFlatPickrConfigForDueDate() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = this.dateTimeFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public ShowDeleteConfirmModal(invoiceHashId: string): void {
    this.isLoading = false;
    this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [
      this.module
    ]);
    this.deleteConfirmModal.show();
    this.invoiceHashId = invoiceHashId;
  }

  public HideDeleteConfirmModal() {
    this.deleteConfirmModal.hide();
  }

  public DeleteConfirmSuccessClick(): void {
    this.deleteConfirmModal.hide();
    this.DeleteInvoice();
  }

  public DeleteInvoice() {
    this.isLoading = true;
    this.invoiceService.DeleteInvoice(this.invoiceHashId).subscribe(
      (res: any) => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetIvoiceList();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [
            this.module
          ]);
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant('LblInvoiceDeleteValidation');
          this.isLoading = false;
          this.ShowSuccessPopup();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnDateSearch() {
    this.GetIvoiceList();
  }

  public GetIvoiceList() {
    this.isLoading = true;
    this.invoiceService
      .GetInvoiceList(this.DataListModel, this.invoiceModel)
      .subscribe(
        res => {
          this.invoiceList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.isLoading = false;

          this.errorModel = [];
          if (typeof res.error == 'string') {
            this.DataListModel.infoMessage = res.error;
          } else if (res.error) {
            this.errorModel = res.error;
            this.DataListModel.infoMessage = this.translate.instant(
              'LblNoDataFound'
            );
          }
          this.IsDirectDebitEnabled();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetIvoiceList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetIvoiceList();
  }

  public OnSearch(event: any) {
    if (event.isReset) {
      this.invoiceModel.startDateTime = '';
      this.invoiceModel.endDateTime = '';
    }

    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetIvoiceList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetIvoiceList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.invoiceService
      .ExportInvoiceList(this.DataListModel, this.invoiceModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = 'Invoice' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public DownloadInvoice(invoiceNumber: string) {
    this.isLoading = true;
    this.invoiceService.DownloadInvoice(invoiceNumber).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = 'Invoice' + new Date().toISOString() + '.pdf';
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public DownloadOfflineInvoicePDF(invoiceNumber: string) {
    this.isLoading = true;
    this.invoiceService.DownloadInvoicePDF(invoiceNumber).subscribe(
      (res: any) => {
        if (res.data) {
          const linkSource = 'data:application/pdf;base64,' + res.data;
          const downloadLink = document.createElement("a");
          const fileName = invoiceNumber + ".pdf";
           if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            var byteCharacters = window.atob(res.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], { type: 'application/pdf' });
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
            setTimeout(function () {
              downloadLink.remove();
            }, 5000);

          }
        }
        else if(res.error)
        {
          this.errorPopupMsg = this.translate.instant('LblFileNotFound');
          this.errorPopupTitle = this.translate.instant('LblError');
          this.errorPopup.show();
        }else{
          this.errorPopupMsg = this.translate.instant('LblNoDataFound');
          this.errorPopupTitle = this.translate.instant('LblError');
          this.errorPopup.show();
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public IsDirectDebitEnabled() {
    this.invoiceService.IsDirectDebitEnabled().subscribe(
      (res: any) => {
        if (res) {
          this.isDirectDebitEnabled = res.data;
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public ShowResendConfirmModal(invoiceNumber: string): void {
    this.invoiceNumber = invoiceNumber;
    this.isLoading = false;
    this.confirmMsg = this.translate.instant('LblResendInvoiceConfirm', [
      this.module
    ]);
    this.resendConfirmModal.show();
  }

  public ShowPaymentLink(paymentLink: string): void {
    this.popupMsg =
      paymentLink && paymentLink.trim()
        ? paymentLink
        : this.translate.instant('LblNoPaymentLinkGenerated');
    this.successPopup.popupTitle = this.translate.instant('LblPaymentLink');
    this.successPopup.show(false);
  }

  public ShowDueDateEditModal(paymentLink: string): void {
    this.popupMsg =
      paymentLink && paymentLink.trim()
        ? paymentLink
        : this.translate.instant('LblNoPaymentLinkGenerated');
    this.successPopup.popupTitle = this.translate.instant('LblPaymentLink');
    this.successPopup.show(false);
  }

  public SuccessConfirmModalClick(): void {
    this.resendConfirmModal.hide();
    this.ResendInvoice();
  }

  public HideConfirmModal(): void {
    this.resendConfirmModal.hide();
  }

  public ResendInvoice() {
    this.isLoading = true;
    this.invoiceService.ResendBookingInvoice(this.invoiceNumber).subscribe(
      res => {
        this.isLoading = false;
        this.popupMsg = this.translate.instant('LblinvoiceResendSuccess', [
          this.module
        ]);
        this.ShowSuccessPopup();
        this.GetIvoiceList();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public CheckEmptyIBAN() {
    var mylist: string[] = [];

    this.missingABANNumber.model = this.invoiceList
      .filter(x => !x.ibanAvailable && x.isChecked && x.includeinDirectDebit)
      .map(y => {
        if (mylist.indexOf(y.driverName + y.instanceName) < 0) {
          let returnObj = {};
          returnObj['driverName'] = y.driverName;
          returnObj['instanceName'] = y.instanceName;
          mylist.push(y.driverName + y.instanceName);
          return returnObj;
        }
      })
      .filter(x => x != null);

    if (this.missingABANNumber.model.length > 0) {
      this.missingABANNumber.show();
    } else {
      this.popupMsg = this.translate.instant('LblNoEmptyIBANFound', [
        this.module
      ]);
      this.ShowSuccessPopup();
    }
  }

  public CreateDirectDebitFile($event: any) {
    if ($event != undefined) {
      this.SetDirectDebitSearchData($event);
      this.createDirectDebitModel.isDirectDebitClick = false;
    } else {
      this.createDirectDebitModel.isDirectDebitClick = true;
    }

    this.invoiceService
      .GetDirectDebitFile(this.selectedFormat, this.invoiceList)
      .subscribe(
        res => {
          this._directDebitFileXML = res.data;
          if (this._directDebitFileXML.length > 0) {
            this.createDirectDebitModel.companyDDModel = this._directDebitFileXML;
            this.createDirectDebitModel.model = this._directDebitFileXML;
            if ($event == undefined) {
              this.createDirectDebitModel.show();
            }
          } else {
            this.successPopup.popupTitle = this.translate.instant('LblWarning');
            this.popupMsg = this.translate.instant('LblNoInvoiceSelected', [
              this.module
            ]);
            this.successPopup.show();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  get isPaymentHistoryAccess(): boolean {
    if (this.invoiceList) {
      return this.invoiceList.some(x => x.isPaymentHistoryView);
    } else {
      return false;
    }
  }

  get isInvoiceEditAccess(): boolean {
    if (this.invoiceList) {
      return this.invoiceList.some(x => x.isEditable);
    } else {
      return false;
    }
  }

  public ShowSuccessPopup(): void {
    this.successPopup.popupTitle = this.translate.instant('LblSuccess');
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public OnDownloadDirectDebitSaved(): void {
    this.GetIvoiceList();
  }

  public SetDirectDebitSearchData($event: any): void {
    this.selectedFormat = $event.format;
  }

  public ShowAddManualInvoiceModal() {
    this.manualInvoicePopup.model = new InvoiceModel();
    this.manualInvoicePopup.show();
  }

  public ShowDueDateChangeModal(invoiceHashId: string): void {
    this.errorModel = [];
    this.invoiceHashId = invoiceHashId;
    this.dueDateUpdatedDate = '';
    this.dueDateValidationMessage = '';
    this.editDueDateModal.show();
  }

  public HideDueDateChangeModal(): void {
    this.editDueDateModal.hide();
  }

  public SuccessDueDateChangeModalClick(): void {
    if (this.dueDateUpdatedDate) {
      this.invoiceService
        .UpdateDueDateForInvoice(this.invoiceHashId, this.dueDateUpdatedDate)
        .subscribe(
          res => {
            if (res.data) {
              this.editDueDateModal.hide();
              this.DataListModel.currentPage = 1;
              this.GetIvoiceList();
              this.popupMsg = this.translate.instant('LblDueDateUpdateSuccess');
              this.ShowSuccessPopup();
            } else {
              this.dueDateValidationMessage = '';
              this.errorModel = res.error;
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    } else {
      this.dueDateValidationMessage = this.translate.instant(
        'LblDueDateRequiredError'
      );
    }
  }

  public ShowInvoiceStatusUpdateModal(
    invoiceHashId: string,
    invoiceStatus: string
  ): void {
    this.isLoading = false;

    if (invoiceStatus == 'CLOSED') {
      this.statusUpdateModalMsg = this.translate.instant(
        'LblConfirmCloseInvoice'
      );
    } else {
      this.statusUpdateModalMsg = this.translate.instant(
        'LblConfirmReOpenInvoice'
      );
    }

    this.invoiceStatusUpdateModel = new InvoiceStatusUpdateModel();
    this.errorModel = [];
    this.GetInvoiceReopenClosedReasons(invoiceStatus);
    this.invoiceStatusUpdateModal.show();
    this.invoiceStatusUpdateModel.invoiceHashId = invoiceHashId;
    this.invoiceStatusUpdateModel.status = invoiceStatus;
  }

  public HideInvoiceStatusUpdateModal() {
    this.invoiceStatusUpdateModal.hide();
  }

  public SuccessInvoiceStatusUpdateConfirmModalClick(): void {
    this.UpdateInvoiceStatus();
  }

  public GetInvoiceReopenClosedReasons(invoiceStatus: string) {
    this.invoiceService.GetInvoiceReopenClosedReasons(invoiceStatus).subscribe(
      res => {
        this.invoiceOpenCloseReasonList = res.data;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public UpdateInvoiceStatus() {
    this.invoiceService
      .UpdateInvoiceStatus(this.invoiceStatusUpdateModel)
      .subscribe(
        res => {
          if (res.data) {
            this.invoiceStatusUpdateModal.hide();
            this.DataListModel.currentPage = 1;
            this.GetIvoiceList();
            this.popupMsg = this.translate.instant(
              'LblInvoiceOpenCloseSuccess',
              [
                this.invoiceStatusUpdateModel.status == 'CLOSED'
                  ? (this.popupMsg = this.translate.instant('LblClosed'))
                  : (this.popupMsg = this.translate.instant('LblReOpen'))
              ]
            );
            this.ShowSuccessPopup();
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  private RenderBookingStatus() {
    // if (this.NormalBookingView) {
    this.invoiceStatusSelect = new SlimSelect({
      select: '#invoiceStatus',
      placeholder: this.LblSelect + ' ' + this.LblStatus,
      showSearch: false,
      showContent: 'down',
      onChange: (info: any) => {
        // if (this.NormalBookingView) {
        this.invoiceModel.invoiceStatusList = info.map((x: any) => x.value);
        // }
        //console.log(info);
      }
      //showContent:'down'
    });
  }

  public SuccessSelectDriverModal($event: any) {
    this.invoiceModel.searchDriverNameList = $event.DriverName;
    this.searchDriverName = this.invoiceModel.searchDriverNameList.join();
    this.invoiceModel.driverHashIdList = $event.DriverHashID;
  }

  public ClearDriver() {
    this.invoiceModel.searchDriverNameList = [];
    this.searchDriverName = "";
    this.invoiceModel.driverHashId = "";
    this.invoiceModel.driverHashIdList = [];
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/invoice-list.component.ts